import React, {
    useCallback,
    useContext,
    useEffect,
} from 'react';

import {
    Box,
    VStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { ToastBoxContext } from '../../contexts/ToastBoxContext';

import PageTitle from '../../components/PageTitle';
import LoginForm, { LoginData } from '../../components/forms/loginForm';

function Login() {
    const {
        toast,
        onCloseToast,
    } = useContext(ToastBoxContext);
    const navigate = useNavigate();
    // close toast message if open
    useEffect(
        () => {
            if (toast) {
                onCloseToast();
            }
        },
        [onCloseToast, toast],
    );

    const onLogIn = useCallback(
        (data: LoginData) => {
            const { email, password } = data;
            console.warn({ email, password });
            navigate('/manage_dimensions');
        },
        [navigate],
    );

    return (
        <VStack
            justifyContent="flex-start"
            spacing={4}
            align="stretch"
        >
            <PageTitle
                title="Login"
            />
            <Box
                minW={700}
                paddingTop={50}
                justifyContent="center"
                alignItems="center"
                alignSelf="center"
            >
                <LoginForm
                    onLogin={onLogIn}
                />
            </Box>
        </VStack>
    );
}

export default Login;
